import { render, staticRenderFns } from "./EmblemRadioButton.vue?vue&type=template&id=27de6451&lang=pug&"
import script from "./EmblemRadioButton.vue?vue&type=script&lang=ts&"
export * from "./EmblemRadioButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports